import type { AppIntegrationOAuthConfigResponse, OAuthConfigResponse, OAuthConfig, AppIntegrationOAuthConfig } from "@/types/auth";
import apiClient from './apiClient';
// import { toaster } from "@/components/ui/toaster";

// We define keys for sessionStorage to avoid typos.
const OAUTH_CONFIG_CACHE_KEY = 'OAuthConfig';
const YOUTUBE_CONFIG_CACHE_KEY = 'youtubeOAuthConfig';

/**
 * A service object for handling authentication-related API calls.
 * Implements sessionStorage caching to ensure configuration is only fetched once per tab session.
 */
export const configService = {

  /**
   * Fetches the public OAuth configuration for the standard Google Login flow.
   * @returns {Promise<OAuthConfig>} The configuration object.
   */
  async getAuthLoginConfig(): Promise<OAuthConfig> {
    try {
      // 1. First, try to get the config from sessionStorage.
      const cachedConfigJSON = sessionStorage.getItem(OAUTH_CONFIG_CACHE_KEY);
      if (cachedConfigJSON) {
        return JSON.parse(cachedConfigJSON);
      }
    } catch (error) { }

    // 2. If not cached, fetch it from the backend.
    try {
      const response = await apiClient.get<OAuthConfigResponse>('/v1/auth/oauth-config');
      const config = response.data.data;

      // 3. Store the fetched config in sessionStorage for subsequent calls.
      try {
        sessionStorage.setItem(OAUTH_CONFIG_CACHE_KEY, JSON.stringify(config));
      } catch (error) { }

      return config;
    } catch (error) {
      // toaster.error({
      //   title: t(''),
      //   description: t(''),
      //   closable: false,
      //   duration: 10000,
      // })
      throw error;
    }
  },

  /**
   * Fetches the public OAuth configuration for the YouTube Integration flow.
   * @returns {Promise<AppIntegrationOAuthConfig>} The configuration object.
   */
  async getYouTubeConfig(): Promise<AppIntegrationOAuthConfig> {
    try {
      // 1. Check cache first.
      const cachedConfigJSON = sessionStorage.getItem(YOUTUBE_CONFIG_CACHE_KEY);
      if (cachedConfigJSON) {
        return JSON.parse(cachedConfigJSON);
      }
    } catch (error) { }

    // 2. Fetch from the backend if not cached.
    try {
      const response = await apiClient.get<AppIntegrationOAuthConfigResponse>('/v1/integrations/youtube/oauth-config');
      const config = response.data.data;

      // 3. Cache the result.
      try {
        sessionStorage.setItem(YOUTUBE_CONFIG_CACHE_KEY, JSON.stringify(config));
      } catch (error) { }

      return config;
    } catch (error) {
      // toaster.error({
      //   title: t(''),
      //   description: t(''),
      //   closable: false,
      //   duration: 10000,
      // })
      throw error;
    }
  }
};